import { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  Dialog,
  Typography,
  useMediaQuery,
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import useStyles from "../Styles/ProjectModalStyles";
import {WaitModalProps} from './../../interfaces' 

import CheckCircle from "@material-ui/icons/CheckCircle";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";

const WaitModal:FC<WaitModalProps> = ({open,setOpen}) => {
  const theme = useTheme();
 
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  const { step } = useContext<any>(SubscriptionContext);
  const [lockState, setLockState] = useState<any>();

  useEffect(() => {
    setLockState(step);
  }, [step])

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  return (
    <>
      <Box component="section">
        

        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
          
            <Box mb={3}>
            <CircularProgress
              variant="indeterminate"
              disableShrink
              size={53}
              thickness={4}
            />
            </Box>
            <ProjectPoolHeading title1="Please" title2="Wait" />
            <Box>
              <Typography variant="body1" className="text-darkslate">
               Your request is in progress. Please patiently sign the <strong className="fw-bold">2 transactions below </strong> to securely stake your GAINS.
               {/* If its takes
                to long click here<Typography  className="fw-bold" component="span"> http://Loremipsem.com </Typography>to accelerate the trx. */}
              </Typography>
              <br />
              <Box>
                <List>
                  <ListItem>
                    <ListItemAvatar>
                      <CheckCircle fontSize="small" color={(lockState === 'VERIFICATION' || lockState === 'LOCKED' || lockState === 'LOCK_VERIFIED' || lockState === 'APPROVED') ? "primary" : "disabled"} /> 
                    </ListItemAvatar>
                    <ListItemText>
                      {
                        (step === 'APPROVAL_FETCH')
                          ? <strong className="fw-bold">Fetching token approval ...</strong>
                          : <strong className="fw-bold">Approve Token Spending</strong>
                      }
                    </ListItemText>
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <CheckCircle fontSize="small" color={(lockState === 'LOCK_VERIFIED') ? "primary" : "disabled"} /> 
                    </ListItemAvatar>
                    <ListItemText>
                      {
                        (step === 'VERIFICATION')
                          ? <strong className="fw-bold">Verification in progress...</strong>
                          : <strong className="fw-bold">Staking GAINS in progress ...</strong>
                      }
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default WaitModal;
